export const SUBSCRIPTIONS = {
    FETCH_SUBSCRIPTION: 'fetchSubscription',
    FETCH_SUBSCRIPTIONS: 'fetchSubscriptions',
    FETCH_SUBSCRIPTION_FROM_ORDER: 'fetchSubscriptionFromOrder',
}
